export const common = {
  // Header
  "nav.home": "Home",
  "nav.vehicles": "Our Vehicles",
  "nav.services": "Services",
  "nav.about": "About",
  "nav.contact": "Contact",
  "header.call": "Call us 24/7",
  "header.book": "Book Now",

  // Hero Section
  "hero.title": "STYLE, POWER, ATTITUDE - THAT'S NPA",
  "hero.subtitle": "Premium Luxury Car Rental in Douala",
  "hero.description": "Experience the pinnacle of luxury transportation with our exclusive fleet of high-end vehicles. From business meetings to special occasions, we provide the perfect vehicle for every moment.",
  "hero.cta": "Discover Our Fleet",
  "hero.whatsapp": "WhatsApp Booking",

  // Vehicles Page
  "vehicles.title": "Our Vehicles",
  "vehicles.subtitle": "Discover our complete vehicle collection",
  "vehicles.all": "All",
  "vehicles.suv": "SUV",
  "vehicles.4x4": "4x4",
  "vehicles.tourism": "Tourism",
  "vehicles.sedan": "Sedan",
  "vehicles.utility": "Utility",
  "vehicles.book": "Book Now",
  "vehicles.seats": "seats",
  "vehicles.transmission": "Automatic",
  "vehicles.fuel": "Gasoline",

  // Fleet Section
  "fleet.title": "Our Premium Fleet",
  "fleet.subtitle": "Discover our collection of luxury vehicles",
  "fleet.year": "Year",
  "fleet.transmission": "Automatic",
  "fleet.fuel": "Gasoline",
  "fleet.seats": "seats",
  "fleet.book": "Book Now",

  // Services Section
  "services.title": "Our Services",
  "services.subtitle": "Premium services for every occasion",
  "services.airport.title": "Airport Transfer",
  "services.airport.desc": "Comfortable and punctual transfers to and from Douala International Airport",
  "services.business.title": "Business Travel",
  "services.business.desc": "Professional transportation for your business meetings and corporate events",
  "services.events.title": "Special Events",
  "services.events.desc": "Luxury vehicles for weddings, celebrations and special occasions",
  "services.chauffeur.title": "Chauffeur Service",
  "services.chauffeur.desc": "Professional drivers available for your comfort and safety",

  // Why Choose Us Section
  "why.title": "Why Choose NPA?",
  "why.subtitle": "Excellence in every detail",
  "why.luxury.title": "Luxury Fleet",
  "why.luxury.desc": "Premium vehicles from 2020-2024, meticulously maintained",
  "why.service.title": "24/7 Service",
  "why.service.desc": "Available anytime, anywhere in Douala and surroundings",
  "why.professional.title": "Professional Drivers",
  "why.professional.desc": "Experienced and courteous drivers for your safety",
  "why.competitive.title": "Competitive Rates",
  "why.competitive.desc": "Best value for luxury car rental in Cameroon",

  // Location Section
  "location.title": "Our Location",
  "location.subtitle": "Visit us in Douala",
  "location.address": "Rhône-Poulenc, Douala, Cameroon",
  "location.hours": "Open 24/7",
  "location.directions": "Get Directions",

  // Booking Section
  "booking.title": "Book Your Luxury Vehicle",
  "booking.subtitle": "Contact us for personalized service and competitive rates",
  "booking.name": "Full Name",
  "booking.phone": "Phone Number",
  "booking.email": "Email Address",
  "booking.vehicle": "Preferred Vehicle",
  "booking.date": "Rental Date",
  "booking.duration": "Rental Duration",
  "booking.message": "Additional Requirements",
  "booking.submit": "Send WhatsApp Request",
  "booking.select": "Select a vehicle",
  "booking.days": "Number of days",

  // Footer
  "footer.tagline": "STYLE, POWER, ATTITUDE - THAT'S NPA",
  "footer.description": "Your trusted partner for luxury car rental in Douala, Cameroon. Experience excellence with our premium fleet.",
  "footer.contact": "Contact",
  "footer.follow": "Follow Us",
  "footer.rights": "All rights reserved.",
  "footer.powered": "WOW (WhatsApp Order Website) powered by Wazi Consulting"
};

export default common;